import React, {createContext, useContext, useLayoutEffect, useState} from 'react';
import {initSticky} from "./auth";
import {Session} from "../types/Session";

const SessionContext = createContext<{
	session: Session | null;
	setSession: React.Dispatch<React.SetStateAction<Session | null>>;
}>({
	session: null, setSession: () => {
	}
});

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
	const [session, setSession] = useState<Session | null>(null);

	useLayoutEffect(() => {
		initSticky();
	}, []);

	return <SessionContext.Provider value={{session, setSession}}>{children}</SessionContext.Provider>;
};

export const useSession = () => useContext(SessionContext);
